module.exports = __webpack_public_path__ + "img/setPassword.e0127708.png";